import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'report-filter-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
})
export class PaymentMethodComponent implements OnInit, AfterViewInit
{
    @Input() filters: {
        check: boolean,
        cash: boolean,
        bank: boolean,
        card: boolean,
        credit: boolean
    } = null;

    @Input() container: FilterContainerComponent;

    ngOnInit() {
        this.container.register(this);
        if (this.filters === null) {
            this.filters = {
                check: true,
                cash: true,
                bank: true,
                card: true,
                credit: true,
            };
        }
    }

    ngAfterViewInit() {
        this.container.notifyReady(this);
    }
}
